import {BillingParams, GET_BILLING} from "./Types";
import {call, put, takeLatest} from "@redux-saga/core/effects";
import {PayloadAction} from "@reduxjs/toolkit";
import Bill from "../../Models/Bill";
import {BillingActions} from "./Slice";
import {toast} from "../../Utils/Utils";
import * as Services from "../../Services/";

function* getBills({ payload }: PayloadAction<BillingParams>) {
  try {
    const res = yield call(Services.getBills, payload);
    if (res.success) {
      const bills = res.results as Bill[];
      yield put(BillingActions.setBills(bills));
    } else {
      throw Error(res.error || 'There was an error.');
    }
  } catch (e) {
    toast(e.message, "error");
  }
}

export default function* billingSaga() {
  yield takeLatest(GET_BILLING, getBills);
}
